import { createStore } from 'owa-satcheljs';

interface RewardsPointsStore {
    // Measured points-text pixel width keyed by coprincipal account key. Replaced wholesale on write
    // so the `pointsWidthByAccount` property read stays MobX-tracked without an ObservableMap.
    pointsWidthByAccount: {
        [accountKey: string]: number;
    };
}

const getRewardsPointsStore: () => RewardsPointsStore = createStore<RewardsPointsStore>(
    'rewardsPointsStore',
    {
        pointsWidthByAccount: {},
    }
);

export default getRewardsPointsStore;
